"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M10.62 6.612a1.86 1.86 0 0 0-.47 1.43L11 16.55a.5.5 0 0 0 .498.45h1a.498.498 0 0 0 .497-.45l.851-8.507a1.86 1.86 0 0 0-.47-1.43c-.704-.777-2.053-.777-2.755 0ZM12.047 16h-.095l-.803-8.058a.842.842 0 0 1 .216-.66.878.878 0 0 1 1.271 0 .849.849 0 0 1 .217.66L12.046 16Zm11.538 1.86L15.071 2.825A3.454 3.454 0 0 0 12 1.001c-1.301 0-2.45.682-3.091 1.862L.422 17.843a3.47 3.47 0 0 0 .073 3.443 3.471 3.471 0 0 0 3.01 1.713h16.988a3.47 3.47 0 0 0 3.01-1.713 3.449 3.449 0 0 0 .081-3.426Zm-.942 2.916A2.478 2.478 0 0 1 20.492 22H3.503a2.48 2.48 0 0 1-2.15-1.224 2.479 2.479 0 0 1-.025-2.51L9.804 3.303A2.467 2.467 0 0 1 11.998 2c.93 0 1.75.487 2.176 1.266l8.513 15.035c.427.783.41 1.707-.045 2.474ZM12 17.999a1.501 1.501 0 0 0 0 3c.826 0 1.5-.673 1.5-1.5s-.674-1.5-1.5-1.5Zm0 2a.5.5 0 1 1 0-1.001.5.5 0 0 1-.002 1.001Z",
    clipRule: "evenodd"
  })]
});